import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Banner from "../../assets/images/banner.svg";
import WhiteBanner from "../../assets/images/White Logo.svg";
import BannerWhite from "../../assets/images/bannerwhite.svg";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { styled } from "@mui/system";
import Typography from "@mui/material/Typography";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Cookies from "js-cookie";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import megaConnectImage from "../../assets/images/megaconnect2.png";
import megaconnectLogo from "../../assets/images/MegaconnectLOGO-06.png";
import axios from "axios";
import CustomSnackbar from "../shared/snackbar";
import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import { ClipLoader } from "react-spinners";
import "../../assets/css/landingpage.css";
import "../../assets/css/header.css";
import { Drawer, Stack } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import DecidingScreen from "./DecidingScreen";

import ConnectLoader from "../../assets/images/connectloader.svg";
import Image from "../image";
import Iconify from "../iconify";
import AccountPopoverWebsite from "../../layouts/account-popover-website";
function NavBarLandingPage({ accessToken }) {
  const navigate = useNavigate();

  const SERVER_URI = process.env.REACT_APP_SERVER_URI;
  const PRE_BOOKING = `${SERVER_URI}/admin/preBook`;
  const AUTHENTIK_LOGIN_URL = `${SERVER_URI}/ssologin`;
  const GET_USER = `${SERVER_URI}/user`;
  const LOGOUT = `${SERVER_URI}/logout`;

  const [openDecidingScreen, setOpenDecidingScreen] = useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const handleOpenDecidingScreen = () => {
    setOpenDecidingScreen(true);
  };

  const handleCloseDecidingScreen = () => {
    setOpenDecidingScreen(false);
  };

  const [openPreBookingScreen, setOpenPreBookingScreen] = useState(false);
  const [openPreConfirmationScreen, setOpenPreConfirmationScreen] =
    useState(false);

  const handleOpenPreBookingScreen = () => {
    setOpenPreBookingScreen(true);
  };

  const handleClosePreBookingScreen = () => {
    setOpenPreBookingScreen(false);
  };

  const handleOpenConfirmationScreen = () => {
    setOpenPreConfirmationScreen(true);
  };

  const handleClosePreConfirmationScreen = () => {
    setOpenPreConfirmationScreen(false);
  };

  const [fullName, setFullName] = useState("");
  const [age, setAge] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [education, setEducation] = useState("");
  const [knownFrom, setKnownFrom] = useState("");
  const [likedFor, setLikedFor] = useState("");
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [variant, setMessageVariant] = useState("success");

  const isFormValid = () => {
    return (
      fullName !== "" &&
      age !== "" &&
      parseInt(age) > 5 && // Age must be a positive number
      parseInt(age) <= 110 && // Age must be less than or equal to 110
      !isNaN(parseInt(age)) && // Age must be a valid number
      email !== "" &&
      /^[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/.test(email) && // Email validation
      phoneNumber !== "" &&
      phoneNumber.length === 10 // Phone number must be exactly 10 digits
    );
  };

  const handleChangeEducation = (event) => {
    setEducation(event.target.value);
  };
  const handleChangeKnownFrom = (event) => {
    setKnownFrom(event.target.value);
  };

  const onMobNoChange = (e) => {
    const inputValue = e.target.value;
    // Check if the input value contains only numeric characters
    if (/^\d*$/.test(inputValue)) {
      // Check if the length is not more than 10 characters
      if (inputValue.length <= 10) {
        setPhoneNumber(inputValue);
      }
    }
  };

  const handleSubmit = () => {
    setIsLoading(true);
    const formData = {
      fullName: fullName,
      age: age,
      email: email,
      phoneNumber: phoneNumber,
      education: education || "NA",
      knownFrom: knownFrom || "NA",
      likedFor: likedFor || "NA",
    };

    axios.post(PRE_BOOKING, formData).then((response) => {
      console.log("Success:", response);
      const responseData = response.data;
      setMessage(responseData.message); // Set message from response
      setFullName("");
      setAge("");
      setEmail("");
      setPhoneNumber("");
      setEducation("");
      setKnownFrom("");
      setLikedFor("");

      if (
        responseData.message ===
        "Thank you for your interest, You will get a mail shortly!"
      ) {
        setIsLoading(false);
        setOpenPreBookingScreen(false);
        setOpenPreConfirmationScreen(true);
      }
      if (response.data.success) {
        setOpen(true);
        setMessageVariant("success");
      } else if (response.data.warning) {
        setIsLoading(false);
        setOpen(true);
        setMessageVariant("warning");
        setFullName("");
        setAge("");
        setEmail("");
        setPhoneNumber("");
        setEducation("");
        setKnownFrom("");
        setLikedFor("");
      } else if (response.data.error) {
        setOpen(true);
        setMessageVariant("error");
        setFullName("");
        setAge("");
        setEmail("");
        setPhoneNumber("");
        setEducation("");
        setKnownFrom("");
        setLikedFor("");
        setIsLoading(false);
      }
    });
  };

  // const [isModalOpen, setModalOpen] = useState(false);
  // const handleOpen = () => {
  //   setModalOpen(true);
  // };
  // const handleClose = () => {
  //   setModalOpen(false);
  // };
  const location = useLocation();

  const isLoginPage = location.pathname === "/user_Login";
  const isSignupPage = location.pathname === "/user_signup";

  if (isLoginPage) {
    window.location.href = "/user_Login"; // Redirect to Authentik SSO login
  }
  const isActiveLink = (pathname) => {
    return location.pathname === pathname;
  };
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };
  const styles = {
    typography: {
      "@media (max-width: 750px)": {
        fontSize: "32px",
        textAlign: "center",
        lineHeight: "50px",
      },
    },
  };
  const titledescription = {
    typography: {
      "@media (max-width: 750px)": {
        fontSize: "20px",
        textAlign: "center",
        lineHeight: "30px",
      },
    },
  };
  const LoginButton = styled(Button)(({ theme }) => ({
    color: "#1E53E8",
    fontFamily: "Roboto Flex",
    backgroundColor: "transparent",
    transition: "background-color 0.3s ease",
    borderColor: "#C7F760",
    fontSize: "16px",
    textTransform: "capitalize",
    // padding: "8px 10px",
    fontWeight: 700,
    "&:hover": {
      backgroundColor: "#C7F760",
      borderColor: "#C7F760",
    },
    "@media (max-width: 400px)": {
      fontSize: "9px",
    },
  }));

  const LogoutButton = styled(Button)(({ theme }) => ({
    color: "#1E53E8",
    fontFamily: "Roboto Flex",
    backgroundColor: "transparent",
    transition: "background-color 0.3s ease",
    borderColor: "#C7F760",
    fontSize: "16px",
    textTransform: "capitalize",
    // padding: "8px 10px",
    fontWeight: 700,
    "&:hover": {
      backgroundColor: "#C7F760",
      borderColor: "#C7F760",
    },
    "@media (max-width: 400px)": {
      fontSize: "9px",
    },
  }));

  const handleSignupRedirect = () => {
    navigate("/user_signup");
  };

  const handleLoginRedirect = () => {
    window.location.href = "/user_Login";
  };

  const handleAuthentikButtonClick = () => {
    window.open(AUTHENTIK_LOGIN_URL, "_self");
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = `${process.env.PUBLIC_URL}/exe file.zip`; // Replace with actual file URL
    link.download = "megaconnect_setup 1 1.zip";
    link.click();
  };
  const isHomePage = location.pathname === "/";
  const [userData, setUserData] = useState(null); // State to store user data

  React.useEffect(() => {
    const fetchUserData = async () => {
      try {
        let token = localStorage.getItem("accessToken");
        let config = {
          headers: { Authorization: `Bearer ${token}` },
        };
        const response = await axios.get(GET_USER, config, {
          withCredentials: true,
        });
        const userId = response.data?.user?._id;
        // console.log("USERID:", userId);
        // console.log("ACCESSTOKEN:", accessToken);

        if (userId || accessToken) {
          setUserData(response.data.user.username); // Store user name
        } else {
          setUserData(null); // Clear user data
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
        setUserData(null); // Clear user data on error
      }
    };


    fetchUserData();
  }, []);

  const handleLogout = async () => {

    try {
      await axios.post(LOGOUT, {}, { withCredentials: true });

      setUserData(null);
      localStorage.clear();
      setTimeout(() => {
        window.location.href = "/";
      }, 100);
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };



  return (
    <div>
      <div className="navbar-landingpage">
        {/* <div className="log-menu">
              <div className="menu">
                
              </div>
            </div> */}
        <div className="image-landing">
          <Link to="/">
            <Image src={Banner} alt="image-landing" sx={{
              width: {
                xs: 90,  // 80px for extra small screens
                sm: 100, // 100px for small screens
                md: 120, // 120px for medium screens and above
              },
            }}
            />
          </Link>
        </div>
        <div className="nav-links">
          <ul
            style={{
              listStyleType: "none",
              display: "flex",
              justifyContent: "center",
              padding: 0,
            }}
          >
            <li>
              <Link
                to="/"
                className={
                  isActiveLink("/") ? "link-of-navbar active" : "link-of-navbar"
                }
              >
                Home
              </Link>
            </li>

            <li>
              <Link
                to="/plans"
                className={
                  isActiveLink("/plans")
                    ? "link-of-navbar active"
                    : "link-of-navbar"
                }
              >
                Pricing
              </Link>
            </li>
            <li>
              <Link
                to="/refer_and_earn"
                className={
                  isActiveLink("/refer_and_earn")
                    ? "link-of-navbar active"
                    : "link-of-navbar"
                }
              >
                Refer & Earn
              </Link>
            </li>
            <li>
              <Link
                to="/contactus"
                className={
                  isActiveLink("/contactus")
                    ? "link-of-navbar active"
                    : "link-of-navbar"
                }
              >
                Contact
              </Link>
            </li>
          </ul>
        </div>

        <div className="log-menu">
          <div className="menu">
            {isLoginPage ? (
              <Button
                onClick={handleSignupRedirect}
                variant="contained"
                sx={{
                  fontFamily: "Roboto Flex",
                  backgroundColor: "#C7F760",
                  color: "#1E53E8",
                  fontWeight: 900,
                  "&:hover": {
                    color: "#1E53E8",
                  },
                }}
              >
                Sign Up
              </Button>
            ) : isSignupPage ? (
              <Button
                onClick={handleLoginRedirect}
                variant="contained"
                sx={{
                  fontFamily: "Roboto Flex",
                  backgroundColor: "#C7F760",
                  color: "#1E53E8",
                  textTransform: "capitalize",
                  fontWeight: 900,
                  "&:hover": {
                    color: "#1E53E8",
                  },
                }}
              >
                Log In
              </Button>
            ) : (
              <IconButton
                color="inherit"
                edge="start"
                onClick={handleDrawerToggle}
              >
                <MenuIcon sx={{ color: "#1D53E7" }} />
              </IconButton>
            )}
          </div>
        </div>

        <Drawer
          variant="temporary"
          anchor="right"
          open={drawerOpen}
          onClose={handleDrawerToggle}
          className="drawer"
          PaperProps={{
            sx: {
              pb: 5,
              width: {
                xs: 320, // Width when the screen size is small (less than 600px)
                sm: 350, // Width when the screen size is medium or larger (600px and above)
              },
              pl: 1,
              borderTopLeftRadius: 15, // Only the top-left corner radius
              borderBottomLeftRadius: 15, // Only the bottom-left corner radius
              boxShadow: '0px 4px 12px rgba(0, 0, 0, 1.50)', // Shadow styling
            },
          }}
        >
          <div className="drawer-content">
            <div
              style={{
                padding: "20px 0px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",

              }}
            >
              <img src={Banner} alt="" width={130} />
              <IconButton onClick={handleDrawerToggle}>
                <CloseIcon sx={{ color: "#1D53E7" }} />
              </IconButton>
            </div>
            <ul style={{ paddingTop: '28px', }}>
              <li>
                <Link
                  to="/"
                  className={`hover-animation-to-text-and-icons ${isActiveLink("/") ? "link-of-drawer-navbar active" : "link-of-drawer-navbar" }`}
                >
                  <div>Home</div>
                  <ArrowForwardIosIcon className="hover-animation-to-text-and-icons" />
                </Link>

              </li>

              <li>
                <Link to="/plans" className={`hover-animation-to-text-and-icons ${isActiveLink("/plans") ? "link-of-drawer-navbar active" : "link-of-drawer-navbar" }`}>
                  <div>Pricing & Plans</div>
                  <ArrowForwardIosIcon className="hover-animation-to-text-and-icons" />
                </Link>
              </li>
              <li>
                <Link to="/refer_and_earn"  className={`hover-animation-to-text-and-icons ${isActiveLink("/refer_and_earn") ? "link-of-drawer-navbar active" : "link-of-drawer-navbar" }`}>
                  <div> Refer & Earn</div>
                  <ArrowForwardIosIcon className="hover-animation-to-text-and-icons" />
                </Link>
              </li>
              <li>
                <Link
                  to="/contactus"
                  className={`hover-animation-to-text-and-icons ${isActiveLink("/contactus") ? "link-of-drawer-navbar active" : "link-of-drawer-navbar" }`}
                >
                  <div>Contact Us</div>
                  <ArrowForwardIosIcon className="hover-animation-to-text-and-icons" />
                </Link>
              </li>
            </ul>
            {/* website login signup buttons */}


          </div>
          {/* Buttons at the bottom */}
          <Box sx={{ p: 2 }} >

            {accessToken || userData ? (
              <>
                <Stack
                  flexGrow={1}

                  direction="row"
                  alignItems="center"
                  // justifyContent="flex-end"
                  spacing={{ xs: 0.5, sm: 1 }}
                  paddingBottom={'26px'}
                >
                  <Stack >
                    <Iconify icon="gg:profile" width="1.5em" height="1.5em" />
                  </Stack>
                  <Typography sx={{
                    fontSize: '16px',
                    fontFamily: 'Roboto Flex',
                    fontStyle: 'italic',
                    fontWeight: '700',
                    lineHeight: '14px',
                    color: "#1D53E7"
                  }}>
                    {userData}
                  </Typography>

                </Stack>
                <Button
                  size="large"
                  fullWidth
                  sx={{
                    justifyContent: "left",
                    backgroundColor: "#C7F760",
                    color: "#1D53E7",
                    mb: 2,
                    p: '8px 16px',
                    fontWeight: 600,
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "#1D53E7",
                      transform: "scale(1.05)",
                      color: "#C7F760",
                      fontWeight: 600,
                      "& .icon": { // Targeting the icon specifically on hover
                        color: "#C7F760",
                      },

                    },
                  }}
                  onClick={() => navigate("/dashboard")}
                >
                  <Stack>
                    <Iconify icon="material-symbols:dashboard-outline" className="icon" sx={{ color: "#1D53E7" }} />
                  </Stack>{" "}
                  &nbsp; Go to Dashboard
                </Button>
                <Button
                  size="large"
                  fullWidth
                  sx={{
                    justifyContent: "left",
                    backgroundColor: "#FFECEC",
                    color: "#F03D55",
                    mb: 1,
                    p: '8px 16px',
                    fontWeight: 600,
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "#FFECEC",
                      transform: "scale(1.05)",
                      color: "#F03D55",
                      fontWeight: 600,
                    },
                  }}
                  onClick={handleLogout}
                >
                  <Stack>
                    <Iconify icon="ant-design:logout-outlined" />
                  </Stack>{" "}
                  &nbsp; Logout
                </Button>
              </>)
              :
              (<>
                <Button
                  size="large"
                  fullWidth
                  sx={{
                    justifyContent: "center",
                    borderRadius: "8px",
                    mb: 2,
                    p: '8px 16px',
                    fontWeight: 600,
                    textTransform: "none",
                    fontFamily: "Roboto Flex",
                    backgroundColor: "transparent",
                    transition: "background-color 0.3s ease",
                    border: "2px solid #C7F760", // Add 5px border with the specified color
                    "&:hover": {
                      backgroundColor: "#C7F760",
                      color: "#1E53E8", // Optional: add text color on hover for contrast
                      fontWeight: 600,

                    },

                  }}
                  onClick={handleLoginRedirect}
                >
                  Login
                </Button>
                <Button
                  size="large"
                  fullWidth
                  sx={{
                    justifyContent: "center",
                    backgroundColor: "#C7F760",
                    color: "#1D53E7",
                    mb: 2,
                    p: '8px 16px',
                    fontWeight: 600,
                    textTransform: "none",
                    "&:hover": {
                      backgroundColor: "#1D53E7",
                      transform: "scale(1.05)",
                      color: "#C7F760",
                      fontWeight: 600,
                      "& .icon": { // Targeting the icon specifically on hover
                        color: "#C7F760",
                      },

                    },
                  }}
                  onClick={() => navigate("/user_signup")}

                >
                  Sign Up
                </Button>
              </>)
            }
          </Box>
        </Drawer>

        <div className="nav-sign-in-button">
          {/* Conditionally render based on whether user is logged in or not */}
          {accessToken || userData ? (
            <div
              className="nav-logged-in"
              style={{ display: "flex", alignItems: "center" }} // Ensure all items are in the same line and vertically aligned
            >
              <AccountPopoverWebsite userName={userData} />
            </div>
          ) : (
            <div className="nav-sign-in-button">
              <Link>
                <LoginButton
                  onClick={handleLoginRedirect}
                  variant="outlined"
                  sx={{ color: "#1E53E8", borderRadius: "8px" }}
                >
                  Log In
                </LoginButton>
              </Link>
              <Link to="/user_signup">
                <Button
                  variant="contained"
                  sx={{
                    fontFamily: "Roboto Flex",
                    backgroundColor: "#C7F760",
                    fontSize: "16px",
                    color: "#1E53E8",
                    boxShadow: "none",
                    borderRadius: "8px",
                    textTransform: "capitalize",
                    fontWeight: 700,
                    "&:hover": {
                      color: "#C7F760",
                    },
                  }}
                >
                  Sign Up
                </Button>
              </Link>
            </div>
          )}
        </div>
      </div>
      {/* <Modal
        open={isModalOpen}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 300, bgcolor: 'background.paper', boxShadow: 24, p: 4 }}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Still working on this Project
          </Typography>
          <IconButton
            sx={{ position: 'absolute', top: 0, right: 0 }}
            color="inherit"
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Your modal content goes here!
          </Typography>
        </Box>
      </Modal> */}
      {/* <Dialog
        open={openDecidingScreen}
        onClose={handleCloseDecidingScreen}
        maxWidth="lg"
      >
        <DecidingScreen handleClose={handleCloseDecidingScreen} />
      </Dialog> */}
      <Dialog
        open={openPreBookingScreen}
        maxWidth="lg"
        onClose={handleClosePreBookingScreen}
      >
        <Box
          sx={{
            padding: "40px",
            border: "2px solid #1D53E7",
            borderRadius: "30px",
            margin: "20px",
          }}
        >
          <IconButton
            edge="end"
            color="error"
            onClick={handleClosePreBookingScreen} // Call the function to close the modal
            aria-label="close"
            style={{ position: "absolute", top: 0, right: 20 }}
          >
            <CloseIcon />
          </IconButton>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <img src={megaconnectLogo} alt="" />
          </div>
          <Typography
            sx={{
              ...styles.typography,
              textAlign: "center",
              padding: "20px",
              fontSize: "46px",
              fontWeight: 900,
              lineHeight: "46px",
              letterSpacing: "0px",
            }}
          >
            Thank you for showing Interest
          </Typography>
          <Typography
            sx={{
              ...titledescription.typography,
              fontSize: "26px",
              fontStyle: "italic",
              fontWeight: 500,
              lineHeight: "36px",
              letterSpacing: "0px",
              textAlign: "center",
            }}
          >
            “Reserve Your MegaConnect Experience”
          </Typography>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
              marginTop: "30px",
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    ...titledescription.typography,
                    color: "#718096",
                    marginTop: "10px",
                  }}
                >
                  Full Name <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  InputProps={{
                    style: {
                      color: "#488CCA",
                      fontFamily: "Poppins",
                      fontSize: "18px",
                      fontStyle: "normal",
                      fontWeight: 700,
                      lineHeight: "normal",
                    },
                  }}
                  style={{ marginTop: "10px" }}
                  type="text"
                  variant="outlined"
                  className="tablepagenition"
                  fullWidth
                  value={fullName}
                  onChange={(e) => {
                    let inputValue = e.target.value;
                    // Limit the input to 30 characters
                    if (inputValue.length > 30) {
                      inputValue = inputValue.slice(0, 30);
                    }
                    // Check if the input value contains only alphabets
                    if (/^[a-zA-Z\s]*$/.test(inputValue)) {
                      setFullName(inputValue);
                    }
                  }}
                  error={!/^[a-zA-Z\s]*$/.test(fullName)} // Set error if fullName contains non-alphabetic characters
                  helperText={
                    !/^[a-zA-Z\s]*$/.test(fullName)
                      ? "Full Name must contain only alphabets"
                      : `${fullName.length}/30 characters`
                  }
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    ...titledescription.typography,
                    textAlign: "left",
                    color: "#718096",
                    marginTop: "10px",
                  }}
                >
                  Age <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  className="tablepagenition"
                  type="text"
                  variant="outlined"
                  style={{ marginTop: "10px" }}
                  InputProps={{
                    style: {
                      color: "#488CCA",
                      fontFamily: "Poppins",
                      fontSize: "18px",
                      fontStyle: "normal",
                      fontWeight: 700,
                      lineHeight: "normal",
                    },
                  }}
                  fullWidth
                  required
                  value={age}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, ""); // Allow only numeric input
                  }}
                  onChange={(e) => setAge(e.target.value)}
                  error={
                    age.trim() !== "" &&
                    (parseInt(age) < 6 ||
                      parseInt(age) > 110 ||
                      isNaN(parseInt(age)))
                  }
                  helperText={
                    age.trim() !== "" &&
                    (parseInt(age) < 6 || isNaN(parseInt(age))
                      ? "Age must be a number greater than 5"
                      : parseInt(age) > 110
                        ? "Age must be less than or equal to 110"
                        : " ")
                  }
                />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    ...titledescription.typography,
                    textAlign: "left",
                    color: "#718096",
                    marginTop: "10px",
                  }}
                >
                  Email <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  InputProps={{
                    style: {
                      color: "#488CCA",
                      fontFamily: "Poppins",
                      fontSize: "18px",
                      fontStyle: "normal",
                      fontWeight: 700,
                      lineHeight: "normal",
                    },
                  }}
                  style={{ marginTop: "10px" }}
                  type="text"
                  variant="outlined"
                  required
                  className="tablepagenition"
                  fullWidth
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  error={
                    email.trim() !== "" &&
                    !/^[a-zA-Z0-9._]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/.test(email)
                  }
                  helperText={
                    email.trim() !== "" &&
                      !/^[a-zA-Z0-9._]+@(?:[a-zA-Z0-9]+\.)+[A-Za-z]+$/.test(email)
                      ? "Please enter a valid email address"
                      : ""
                  }
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    ...titledescription.typography,
                    textAlign: "left",
                    color: "#718096",
                    marginTop: "10px",
                  }}
                >
                  Phone Number <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  className="tablepagenition"
                  type="text"
                  variant="outlined"
                  style={{ marginTop: "10px" }}
                  // size="small"
                  InputProps={{
                    style: {
                      color: "#488CCA",
                      fontFamily: "Poppins",
                      fontSize: "18px",
                      fontStyle: "normal",
                      fontWeight: 700,
                      lineHeight: "normal",
                    },
                  }}
                  fullWidth
                  required
                  value={phoneNumber}
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, ""); // Allow only numeric input
                  }}
                  onChange={(e) => onMobNoChange(e)}
                  error={phoneNumber.length > 0 && phoneNumber.length !== 10}
                  helperText={
                    phoneNumber.length > 0 && phoneNumber.length !== 10
                      ? "Please enter a 10-digit phone number"
                      : " "
                  }
                />
              </Grid>
            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    ...titledescription.typography,
                    textAlign: "left",
                    color: "#718096",
                    marginBlock: "10px",
                  }}
                >
                  Education
                </Typography>
                <FormControl fullWidth variant="filled">
                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    value={education}
                    label="Education"
                    fullWidth
                    onChange={handleChangeEducation}
                  >
                    <MenuItem value="Pre Primary 1st to 5th">
                      Pre Primary 1st to 5th
                    </MenuItem>
                    <MenuItem value="Primary 6th to 8th">
                      Primary 6th to 8th
                    </MenuItem>
                    <MenuItem value="High School 9th to 10th">
                      High School 9th to 10th
                    </MenuItem>
                    <MenuItem value="Junior College 11th or 12th">
                      Junior College 11th or 12th
                    </MenuItem>
                    <MenuItem value="Senior College 1st Year to 5th Year">
                      Senior College 1st Year to 5th Year
                    </MenuItem>
                    <MenuItem value="Graduated">Graduated</MenuItem>
                    <MenuItem value="Post Graduate">Post Graduate</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={6}>
                <Typography
                  sx={{
                    ...titledescription.typography,
                    textAlign: "left",
                    color: "#718096",
                    marginBlock: "10px",
                  }}
                >
                  Where did you hear about us ?
                </Typography>
                <FormControl fullWidth variant="filled">
                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    value={knownFrom}
                    label="Where did you hear about us?"
                    onChange={handleChangeKnownFrom}
                  >
                    <MenuItem value="Family & Friends">
                      Family & Friends
                    </MenuItem>
                    <MenuItem value="Google">Google</MenuItem>
                    <MenuItem value="Facebook">Facebook</MenuItem>
                    <MenuItem value="Instagram">Instagram</MenuItem>
                    <MenuItem value="Twitter">Twitter</MenuItem>
                    <MenuItem value="LinkedIn">LinkedIn</MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            <Typography
              sx={{
                ...titledescription.typography,
                textAlign: "left",
                color: "#718096",
                marginTop: "10px",
              }}
            >
              What did you liked the most about our product?
            </Typography>
            <TextField
              id="outlined-multiline-static"
              sx={{ marginTop: "20px" }}
              fullWidth
              multiline
              rows={4}
              className="tablepagenition"
              value={likedFor}
              onChange={(e) => {
                const inputValue = e.target.value;
                // Check if the input value contains only alphabets and is within 250 characters
                if (
                  /^[a-zA-Z\s]*$/.test(inputValue) &&
                  inputValue.length <= 250
                ) {
                  setLikedFor(inputValue);
                }
              }}
              error={!/^[a-zA-Z\s]*$/.test(likedFor)} // Set error if likedFor contains non-alphabetic characters
              helperText={
                !/^[a-zA-Z\s]*$/.test(likedFor)
                  ? "Description must contain only alphabetic characters"
                  : `${likedFor.length}/250 characters`
              }
            />
          </Box>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <Button
              variant="contained"
              onClick={handleSubmit}
              disabled={!isFormValid()}
              sx={{
                fontFamily: "Roboto Flex",
                width: "400px",
                backgroundColor: "#C7F760",
                color: "#1E53E8",
                textTransform: "none",
                fontWeight: 900,
                "&:hover": { backgroundColor: "#1E53E8", color: "#C7F760" },
                "@media (max-width: 600px)": { width: "100%" },
              }}
            >
              Submit
            </Button>
          </div>
        </Box>
      </Dialog>
      <Dialog
        open={openPreConfirmationScreen}
        maxWidth="lg"
        onClose={handleClosePreConfirmationScreen}
      >
        <Box sx={{ padding: "40px" }}>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <img src={Banner} alt="" />
          </div>
          <Typography
            sx={{
              ...styles.typography,
              fontFamily: "Poppins",
              fontSize: "56px",
              fontWeight: 900,
              lineHeight: "66px",
              letterSpacing: "0px",
              textAlign: "center",
              padding: "30px",
            }}
          >
            Thanks for<span style={{ color: "#488CCA" }}> Booking</span> Your
            Spot!
          </Typography>
          <Typography
            sx={{
              ...titledescription.typography,
              fontSize: "26px",
              fontStyle: "italic",
              fontWeight: 500,
              lineHeight: "36px",
              letterSpacing: "0px",
              textAlign: "center",
            }}
          >
            We've received your information and our team will be in touch
            shortly to confirm your reservation and answer any questions you may
            have.
          </Typography>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <Button
              variant="contained"
              onClick={handleClosePreConfirmationScreen}
              sx={{ fontFamily: "Roboto Flex", width: "400px" }}
            >
              Back to home
            </Button>
          </div>
        </Box>
      </Dialog>
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.5)", // Adjust the opacity as needed
            backdropFilter: "blur(3px)", // Adjust the blur radius as needed
            zIndex: 9999, // Ensure the overlay is above other content
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              position: "fixed",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <img
              src={ConnectLoader}
              alt=""
              style={{ color: "#374ad7", fontSize: "50%" }}
            />
            {/* <img color={}  /> */}
          </Box>
        </div>
      )}
      <CustomSnackbar message={message} variant={variant} open={open} />
    </div>
  );
}

export default NavBarLandingPage;
